import { useOrgStore } from '@/stores/org-store';
import { apiRequest } from '@/utils/api-request';
import { EncryptionStatus } from './encryption-types';

export const getEncryptionStatus = async (
  fresh?: boolean,
): Promise<EncryptionStatus> => {
  const orgId = useOrgStore.getState().currentOrg?.orgid;
  if (!orgId) {
    throw new Error('No organization selected');
  }

  const url = fresh
    ? `/organizations/${orgId}/encryption/status?fresh=true`
    : `/organizations/${orgId}/encryption/status`;

  const response = await apiRequest<EncryptionStatus>({
    url,
    method: 'GET',
    target: 'platform',
  });

  if (response?.detail) {
    throw new Error(response.detail || 'Failed to get encryption status');
  }

  return response.data ?? { configured: false };
};
